import React from 'react';
import Card from "../src/components/Card"

export default function App() {
  return (
      <React.Fragment>
          <Card />
      </React.Fragment>
  );
}
